import * as React from 'react';

import { Radio } from '@hotjar/hotsauce';

export type FormMode = 'create' | 'update';

interface FormModeOptionProps {
  onChange: (newMode: FormMode) => void;
  currentMode: FormMode;
  mode: FormMode;
  label: string;
  children: React.ReactNode;
}

export const FormModeOption = ({
  onChange,
  currentMode,
  mode,
  label,
  children,
}: FormModeOptionProps): JSX.Element => {
  const name = 'segment-form-mode';
  const checked = currentMode === mode;
  const handleModeChange = () => {
    onChange(mode);
  };

  return (
    <>
      <Radio
        id={`${name}-${mode}`}
        value={mode}
        onChange={handleModeChange}
        isChecked={checked}
        name={name}
        labelContent={label}
      />
      {checked && children}
    </>
  );
};
